import { useEffect, type ReactNode } from 'react'
import BottomSheetContent from '../../../../../../../components/BottomSheetComponents/BottomSheetContent'
import { SecondaryButton } from '../../../../../../../components/execution/SecondaryButton'
import { EventNames } from '../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../utils/appBridge'
import {
  PlansBottomSheet,
  PlansScreen,
  PlansSipSheetEventIds
} from '../../../../analytics/plansEvents'

type SipPlanRecommendationSheetLayoutProps = {
  onDismiss: () => void
  isLoading: boolean
  isFetchFailed: boolean
  children: ReactNode
  analyticsScreen?: string
}

export function SipPlanRecommendationSheetLayout({
  onDismiss,
  isLoading,
  isFetchFailed,
  children,
  analyticsScreen = PlansScreen.SipYourPlanRecommendation
}: SipPlanRecommendationSheetLayoutProps) {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.BottomSheetLoad,
      payload: {
        ScreenName: analyticsScreen,
        eventId: PlansBottomSheet.SipRecommendation,
        bottomSheetName: PlansBottomSheet.SipRecommendation
      }
    })
  }, [analyticsScreen])

  function handleClose() {
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        ScreenName: analyticsScreen,
        eventId: PlansSipSheetEventIds.Close,
        buttonLabel: 'Close'
      }
    })
    onDismiss()
  }

  const bottomSheetBodyClassName =
    isLoading || isFetchFailed
      ? '!px-0 !pb-2 !overflow-y-auto no-scrollbar'
      : '!px-0 !pb-2 !overflow-visible'

  return (
    <BottomSheetContent
      onDismiss={handleClose}
      heading={undefined}
      bottomSheetHeadClassName="!pt-6"
      bottomSheetBodyClassName={bottomSheetBodyClassName}
      bottomSheetCtaWrapperClassName="z-10"
      bottomSheetCtas={(
        <SecondaryButton
          label="Close"
          onClick={handleClose}
          secondaryButtonClassName="!h-[56px] !text-[16px]"
        />
      )}
    >
      {children}
    </BottomSheetContent>
  )
}
